module.exports = __webpack_public_path__ + "static/img/gptModel21.8e80bf10.png";